var timeoutPopover,
    disablePopstate = false,
    magnificPopup,
    initRichContent,
    players = [];

(function ($) {
    $(function () {

            /**
             * Lazy Loader
             * @see https://github.com/jetmartin/responsive-lazy-loader
             */

            function initLazyLoader() {
                $('*[data-src].lazy:not(.ce-regular)').responsiveLazyLoader({
                    distance: 500
                });
                $('*[data-src].lazy.ce-regular').responsiveLazyLoader({
                    mediaQueries: {
                        'm': "(max-width: 480px)",
                        't': "(min-width: 481px) and (max-width: 768px)",
                        'd': "(min-width: 769px)"
                    },
                    distance: 500
                });
            }

            /**
             * General AJAX events
             */
            $(document).ajaxStart(function () {
                $('body,a,button').css('cursor', 'wait');
            });

            $.support.cors = true;

            window.initCart();

            /**
             * Lang Switch after history push does not reflect current page
             */
            $(document).on('click', '.lang-switcher a', function () {
                // set language cookie
                Util.setCookie('user_ni_user_language', $(this).data('code'), null, 1000 * 60 * 60 * 24 * 10);
                if (Util.getParameter('id') == '') {
                    var path = window.location.pathname + window.location.search;
                    $(this).attr('href', '/' + $(this).data('code') + path.substring(3, path.length));
                }
                return true;
            });

            /**
             *  Sound Link Initialization
             */

            function initSoundLinks() {
                if (typeof(nisp) !== "undefined") {
                    try {
                        var soundLinks = $("a[data-type=audio],div.finder-product-media div[data-type=audio]");
                        soundLinks.off('click');
                        soundLinks.click(function (e) {
                            var player_button = $(e.delegateTarget);
                            var id = player_button.attr("data-content");
                            var thumb = player_button.find(".icon");

                            if (thumb.hasClass('nisp-paused') || thumb.hasClass('nisp-playing')) {
                                nisp.pauseOrPlay();
                            } else {
                                // attach statechange callback (will replace old callback if exists)
                                nisp.statechange(function (state) {
                                    if (state == 'loading') {
                                        thumb.removeClass('nisp-paused').removeClass('nisp-playing').addClass('nisp-loading');
                                    } else if (state == 'playing') {
                                        thumb.removeClass('nisp-loading').removeClass('nisp-paused').addClass('nisp-playing');
                                    } else if (state == 'paused') {
                                        thumb.removeClass('nisp-playing').removeClass('nisp-loading').addClass('nisp-paused');
                                    } else {
                                        thumb.removeClass('nisp-playing').removeClass('nisp-paused').removeClass('nisp-loading');
                                    }
                                });
                                // play sound
                                var streamUrl = $(this).attr("href");
                                nisp.fetchSound(id, streamUrl);
                            }
                            e.preventDefault();
                        });
                    } catch (e) {

                    }
                }
            }

            /**
             * Modal dialog/Video Layer initialization
             */
            magnificPopup = $.magnificPopup.instance;

            function initPopup() {

                $('.modal-inline').magnificPopup({
                    type: 'inline',
                    closeBtnInside: true,
                    removalDelay: 300,
                    mainClass: 'mfp-fade'
                });

                $('.modal-ajax').magnificPopup({
                    type: 'ajax',
                    closeBtnInside: true,
                    removalDelay: 300,
                    mainClass: 'mfp-fade'
                });

                $('a[data-type=video]').magnificPopup({
                    type: 'iframe',
                    removalDelay: 300,
                    mainClass: 'mfp-fade',
                    callbacks: {
                        open: function () {
                            if (typeof(nisp) !== "undefined") {
                                nisp.pause();
                            }
                        }
                    },
                    iframe: {
                        patterns: {
                            youtube: {
                                index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).
                                id: function (url) {
                                    return url;
                                },
                                src: '%id%&autoplay=0' // URL that will be set as a source for iframe.
                            }
                        }
                    }
                });

                // modal image
                $('.modal-image-link').magnificPopup({
                    type: 'image',
                    closeBtnInside: true,
                    removalDelay: 300,
                    mainClass: 'mfp-fade'
                });

                // ie9 hack - cross protocol ajax requests don't work
                if (Util.isLessThanIE10()) {
                    $('#loginLink').unbind().click(function () {
                        Account.goToLoginPage();
                        return false;
                    });
                }

            }

            /**
             * Deeplinking for Audio/Video
             */
            function initDeeplinks() {
                if (typeof(Media) !== "undefined") {
                    Media.init();
                }
            }

            function initAffix() {
                if (typeof(DetailPages) !== "undefined") {
                    DetailPages.initAffix();
                }
            }

            function initGallery() {

                /**
                 * ResponsiveLazyLoader sets data-src which is used as lazy loading source for slick. Reason: Height calculation and specific events of slick are
                 * based on the slick's lazy loading functionality so we couldn't use our one. Beyond that there is some special handling for arrows and loading
                 * workflow.
                 */

                $('.slick-gallery .slick-slice img.lazy-gallery').responsiveLazyLoader({

                    force: true, // target image is rendered into data-src which is moved to src by slick on demand

                    initialized: function () {

                        // perform actions when image was loaded
                        $('.slick-gallery img.lazy-gallery')
                            .one('load', function () {
                                $(this).parent().removeClass('spinner');
                                // adjust height after lazy loading - slick has problems to trigger this when calling a page by ajax
                                $(this).parents('.slick-gallery').get(0).slick.animateHeight();
                                $(this).parents('.slick-gallery').get(0).slick.setPosition();
                            });

                        // init slick galleries
                        $('.slick-gallery')
                            .slick({
                                dots: true,
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                initialSlide: 0,
                                speed: 300,
                                adaptiveHeight: true,
                                accessibility: true,
                                lazyLoad: 'ondemand',
                                prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><span></span></button>',
                                nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><span></span></button>',
                            })
                            .on('setPosition', function () {
                                // arrow position calculation
                                var elm = $(this),
                                    slideImageHeight = elm.find('.slick-track .slick-slide:nth-child(2) img').height(),
                                    slideArrowBox = elm.find('.slick-prev span').height(),
                                    slideArrowBoxDistance = slideImageHeight / 2 - slideArrowBox / 2;
                                elm.find('.slick-prev span, .slick-next span').css('top', slideArrowBoxDistance);
                            })
                            .on('beforeChange', function () {
                                // load all images on first user event
                                var lazyImages = $(this).find('img[data-lazy]'),
                                    lazyImageCount = lazyImages.length;
                                if (lazyImageCount > 0) {
                                    lazyImages.each(function () {
                                        $(this).attr('src', $(this).attr('data-lazy'))
                                            .removeAttr('data-lazy')
                                            .removeClass('slick-loading');
                                    });
                                }
                            });

                    }

                });

            }


            function initContentVideoOnDemand() {
                var videoDeps = (function() {
                    var basePath = '/typo3conf/ext/ni_assets/Resources/Public/';

                    if (Util.isProductionMode()) {
                        return [
                            basePath + 'Dist/video.js',
                            basePath + 'Dist/video.css'
                        ];
                    } else {
                        return [
                            basePath + 'Libs/flowplayer/skin/minimalist.css',
                            basePath + 'Libs/flowplayer/skin/ni.css',
                            basePath + 'Libs/flowplayer/flowplayer.js',
                            basePath + 'Libs/flowplayer/hlsjs/hls.light.min.js',
                            basePath + 'Js/jquery.viewport.js',
                            basePath + 'Js/video.js'
                        ];
                    }
                })();

                // Load flowplayer on demand
                if ($('[data-video-src]').length) {
                    Util.ensureLoaded(videoDeps).then(function () {
                        initContentVideos();
                    });
                }

            }

            function initAngular() {
                if (window.angular) {
                    angular.element('[ng-app]').each(function(i, e) {
                        var element = angular.element(e);

                        if (!element.injector()) {
                            angular.bootstrap(element, [element.attr('ng-app')]);
                        }

                    })
                }
            }

            /**
             * Watch for location_country cookie changes from nicom-login
             * The country value stored in the cookie is used extensively,
             * so reload the page if a new value is set after initial page load
             * For more context, see:
             * https://github.com/NativeInstruments/nicom-login/pull/29
             * https://confluence.bln.native-instruments.de/pages/viewpage.action?pageId=246685350
             * https://www.native-instruments.com/bugtracker/browse/WWW-8865
             * https://www.native-instruments.com/bugtracker/browse/WWW-8406
             */
            function watchLocalizationCountry() {
                var localizationCountry = Util.getCountry();

                function handleChange() {
                    var nextLocalizationCountry = Util.getCountry();

                    if (nextLocalizationCountry !== localizationCountry) {
                        window.location.reload(false);
                    }
                }

                window.emitter.on('localization-country-set', handleChange);
            }

            /**
             * Rich Content initialization
             * (put everything in here that needs to be called on document.ready and ajaxComplete)
             */
            initRichContent = function initRichContent() {
                initLazyLoader();
                initPopup();
                initGallery();
                if (typeof(nisp) !== "undefined") {
                    if (!nisp.hasBeenInitialized()) {
                        nisp.init();
                    }
                    initSoundLinks();
                }
                initAffix();
                initContentVideoOnDemand();
                initAngular();
            };

            $(document).ready(function () {
                if (Modernizr.history && Util.getParameter('content') != '') {
                    history.replaceState(true, null, window.location.href);
                }
                // we store our callback for when the sound player is ready
                if (typeof nisp != "undefined") {
                    nisp.ready(function () {
                        initDeeplinks();
                    });
                }
                watchLocalizationCountry();
                // then we trigger the actual initialization
                initRichContent();
            });

            /**
             * Tab configuration for media pages
             */
            $('.nav-tabs a').click(function (e) {
                e.preventDefault();
                $(this).tab('show');
            });

            /**
             * Menu click event handler, used by <a> and <option> tags
             * Loads requested page by ajax or normal link in case the css class 'noajax' is set
             */
            var ajaxContentClickHandler = function (e) {
                var that = $(this),
                    noAjaxLink = that.hasClass('noajax'),
                    noAjaxOption = that.find(':selected').hasClass('noajax'),
                    href = that.find(':selected').length > 0 ? that.find(':selected').data('href') : that.attr('href');
                if (!noAjaxLink && !noAjaxOption && !Util.isLessThanIE10()) {
                    Util.getAjaxContent(href, function (data) {
                        Util.insertScripts(data, function () {

                            $('#ajax-content').html(data);

                            // inits
                            initRichContent();

                            // scroll
                            if (!that.hasClass('noscroll')) {
                                $('html,body').scrollTop(0);
                            }

                            // execute only on browsers which support history push
                            if (!that.hasClass('nohistorypush')) {
                                if (Modernizr.history) {
                                    // before pushing new state we enable coming back to this one
                                    // this fixes a bug when returning to first loaded page was blocked
                                    window.history.replaceState(true, document.title, window.location.href);
                                    // add new history state
                                    window.history.pushState(true, document.title, href);
                                }
                            }

                            // set title
                            var title = $(data).find('#ajax-meta').data('title');
                            if (title) {
                                document.title = title;
                            }

                            if (typeof DetailPages != 'undefined') {
                                // what's this call for?!
                                DetailPages.initAffix();
                            }

                            // fires track page
                            if (!that.hasClass('notrack')) {
                                Track.page();
                            }

                        });
                    });
                    e.preventDefault();
                }
                if (noAjaxOption) {
                    Util.goToUrl(href);
                }
            };

            var ajaxContentLinks = [
                '.welcome-header-navigation a',
                '.btn-stage-buy',
                '.btn-stage-demo',
                '.btn-stage-more-media',
                '.btn-stage-apply',
                '#price-box .btn-primary'
            ].join(',');

            $(document).on('click', ajaxContentLinks, ajaxContentClickHandler);

            /**
             * History back
             */
            $(window).bind('popstate', function (e) {
                var popped = ('state' in window.history && window.history.state !== null);
                if (popped && !disablePopstate) {
                    var href = window.location.href;
                    Util.getAjaxContent(href, function (data) {
                        Util.insertScripts(data, function () {
                            $('#ajax-content').html(data);
                            initRichContent();
                        });
                    });
                    e.preventDefault();
                }
            });

            /**
             * AJAX Complete Event
             */
            $(document).ajaxComplete(function (event, xhr, settings) {
                $('body,a,button').css('cursor', '');
                // forms
                $('.ajaxContent form:not(.noajax)').submit(function () {
                    var form = this;
                    $(form).find("[type=submit]").button('Waiting');
                    $.ajax({
                        url: $(this).attr('action'),
                        type: $(this).attr('method'),
                        data: $(this).serialize(),
                        xhrFields: {
                            withCredentials: true
                        },
                        success: function (response, status, request) {
                            // redirect
                            if (request.getResponseHeader('X-Modal-Location') &&
                                Util.isNiUrl(request.getResponseHeader('X-Modal-Location'))) {
                                Util.goToUrl(request.getResponseHeader('X-Modal-Location'));
                            }
                            // redirect after login
                            else if (Util.getCookie('redirectAfterLogin') != '' &&
                                Account.isLoggedIn() &&
                                Util.isNiUrl(Util.getCookie('redirectAfterLogin'))) {
                                Util.goToUrl(Util.getCookie('redirectAfterLogin'));
                                Util.removeCookie('redirectAfterLogin');
                            }
                            // redirect after login jsvar
                            else if (Account.redirectAfterLogin != '' &&
                                Account.isLoggedIn() &&
                                Util.isNiUrl(Account.redirectAfterLogin)) {
                                Util.goToUrl(Account.redirectAfterLogin);
                            }
                            // reload
                            else if (request.getResponseHeader('X-Page-Reload') == 1 || $(response).find('.ajax-meta').data('reload')) {
                                Util.goToUrl(Util.updateUrlQueryParameter(self.location.href, 'refresh', Util.getRandomString()));
                            }
                            // close
                            else if (request.getResponseHeader('X-Modal-Close') == 1 || $(response).find('.ajax-meta').data('close')) {
                                magnificPopup.close();
                            }
                            // replace content
                            else {
                                $(form).closest('.ajaxContent').html(response);
                            }
                        }
                    });
                    return false;
                });
                // links
                $('.ajaxContent a.ajax').click(function () {
                    $(this).closest('.ajaxContent').load($(this).attr('href'));
                    return false;
                });
            });

            /**
             * Forms
             */
            $(document).on('click', 'button[type=submit].loading, input[type=submit].loading', function () {
                var btn = $(this);
                btn.button('loading');
                $(document).ajaxStop(function () {
                    btn.button('reset');
                });
            });

            /**
             * Language PopIn
             */
            if (!Util.getCookie('lang_pref') && Util.isWwwPage() && Util.isProductionMode()) {
                var preferredLanguage = Util.getPreferredLanguage();
                if (preferredLanguage != Util.getLang() &&
                    preferredLanguage != null &&
                    typeof preferredLanguageTranslations == 'object' &&
                    preferredLanguageTranslations[preferredLanguage]
                ) {
                    var d = new Date();
                    $('#preferred-language-title').text(preferredLanguageTranslations[preferredLanguage].title);
                    $('#preferred-language-text').text(preferredLanguageTranslations[preferredLanguage].text);
                    $('#preferred-language-change').text(preferredLanguageTranslations[preferredLanguage].change).attr('href', Util.addParameter(document.location.href, 'lang', preferredLanguage));
                    $('#preferred-language a').click(function () {
                        Util.setCookie('lang_pref', d.getTime(), null, 1000 * 3600 * 24 * 30);
                    });
                    setTimeout(function () {
                        $('#preferred-language').fadeIn('slow').addClass('in');
                        $('.popover-lang .close').click(function () {
                            $('#preferred-language').fadeOut('slow').removeClass('in');
                            Track.analyticsEvent('Lang Recommendation', 'Not Changed from', Util.getLang() + ' to ' + preferredLanguage, 1);
                            return false;
                        });
                        $('#preferred-language-change').click(function () {
                            Track.analyticsEvent('Lang Recommendation', 'Changed from', Util.getLang() + ' to ' + preferredLanguage, 1);
                        });
                    }, 5000);
                }
            }

            $(document).on('submit', 'form', function (e) {
                var form = $(this);
                if (!form.data('ajaxAction')) {
                    return;
                }
                e.preventDefault();
                $.ajax({
                    url: form.attr('data-ajax-action'),
                    type: form.attr('method'),
                    dataType: 'html',
                    data: form.serialize(),
                    success: function (data) {
                        var target = $('#' + form.attr('data-ajax-target'));
                        (target.length > 0 ? target : form).replaceWith(data);
                    },
                    error: function (xhr, err) {
                    }
                });
                return false;
            });

            // Load content via ajax


            $('[data-ajax-include]').each(function(i, element) {
                $(element).addClass('ajax-include-loading');
                if ($(element).data('ajax-placeholder')) {
                    $(element).html($(element).data('ajax-placeholder'));
                }
                $.get($(element).data('ajax-include'), function(response) {
                    $(element).html(response);
                    $(element).removeClass('ajax-include-loading');
                });
            });


        }
    );
})(jQuery);
